import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectIds } from '../../phone-number-register/state/phone-number-register.reducer';
import { selectIsOnSystemPage } from '../../phone-number-register/state/phone-number-register.selectors';
import { phoneNumberDetailFeatureKey, State } from './phone-number-detail.reducer';

export const phoneNumberDetailFeature = createFeatureSelector<State>(phoneNumberDetailFeatureKey);

export const getPhoneNumber = createSelector(phoneNumberDetailFeature, (state) => {
   return state.phoneNumber;
});

export const getPhoneNumberCallState = createSelector(phoneNumberDetailFeature, (state) => {
   return state.callState;
});

export const selectNonSystemIds = createSelector(selectIds, selectIsOnSystemPage, (ids, isOnSystemPage) =>
   isOnSystemPage ? [] : ids
);
